/** Markdown → HTML a megjelenítéshez.
 *
 * Ugyanaz a renderelő-család, mint a backend SSR-jében (`markdown-it-py`) és az admin
 * szerkesztőjében — így a szerkesztő, a melléklet és a publikus oldal ugyanazt mutatja.
 *
 * Biztonság: `html: false`, tehát a forrásban lévő nyers HTML escape-elve jelenik meg
 * (nem kerül a DOM-ba), a linkeket pedig a markdown-it `validateLink`-je szűri
 * (`javascript:`, `vbscript:`, `file:` nem megy át). A tartalom emellett moderált.
 */
import MarkdownIt from "markdown-it";

const md = new MarkdownIt("commonmark", { html: false, linkify: true, breaks: false });

// A tartalmi linkek külső oldalra visznek — ne vesszen el a melléklet.
const defaultLinkOpen =
  md.renderer.rules.link_open ??
  ((tokens, idx, options, _env, self) => self.renderToken(tokens, idx, options));

md.renderer.rules.link_open = (tokens, idx, options, env, self) => {
  tokens[idx].attrSet("target", "_blank");
  tokens[idx].attrSet("rel", "noreferrer noopener");
  return defaultLinkOpen(tokens, idx, options, env, self);
};

export function renderMarkdown(source: string): string {
  return md.render(source ?? "");
}
